import { AvaiableProductsResult } from "../types/AvailableProducts";
interface Props {
  availableProducts: AvaiableProductsResult;
}
export const ApartmentBox = ({ availableProducts }: Props) => {
  const { useplace } = availableProducts;
  return (
    <>
      {useplace.site.installation === "installed" ? (
        <div>
          <div className="text-2xl text-gray-600 mb-4">
            Här är vad vi kan hjälpa dig med
          </div>
          <div
            className="w-full  relative p-8 flex flex-col justify-center items-center text-center gap-4 text-white rounded-md"
            id="order-popup-content "
            style={{
              backgroundSize: "cover",
              backgroundImage: `url("https://images.unsplash.com/photo-1496181133206-80ce9b88a853?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1742&q=80")`,
              backgroundPosition: "50% 75%",
            }}
          >
            <div className="absolute inset-0 bg-black/40 rounded-md" />
            <div className="z-10 flex flex-col justify-center text-center space-y-4 items-center">
              <span className="text-3xl font-normal">
                Kom igång med dina tjänster
              </span>
              <span>
                Din lägenhet är ansluten till Lunets öppna stadsnät du väljer
                fritt bland tjänsterna hos våra tjänsteleverantörer. De erbjuder
                internet, TV, telefoni och smarta tjänster.
              </span>
              <a
                href={`/kundservice/kom-igang/${
                  useplace.type === "house" ? "villa" : "lagenhet"
                }`}
                className="bg-yellow-300 px-8 py-1 rounded-sm"
              >
                Hjälp att komma igång med dina tjänster
              </a>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="text-2xl text-gray-600 mb-4">
            Här är vad vi kan hjälpa dig med
          </div>
          <div
            className="w-full relative  p-8 flex flex-col justify-center items-center text-center gap-4 text-white rounded-md"
            id="order-popup-content"
            style={{
              backgroundSize: "cover",
              backgroundImage: `url("https://images.unsplash.com/photo-1496181133206-80ce9b88a853?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1742&q=80")`,
              backgroundPosition: "50% 75%",
            }}
          >
            <div className="absolute inset-0 bg-black/40 rounded-md" />
            <div className="z-10 flex flex-col justify-center text-center space-y-4 items-center">
              <span className="text-3xl font-normal">
                Kontakta din fastighetsägare
              </span>
              <span>
                Eftersom din lägenhet för närvarande inte är ansluten till
                stadsnätet behöver du kontakta din fastighetsägare för att höra
                när ni kan beställa tjänster eller vem som levererar tjänsterna
                till er.
              </span>
              <a
                href={`/kundservice/kom-igang/${
                  useplace.type === "house" ? "villa" : "lagenhet"
                }`}
                className="bg-secondary text-white px-8 py-1 rounded-sm"
              >
                Kontakta Lunet
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
